var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _path4, _path5, _path6, _rect0, _rect1, _ellipse4, _ellipse5, _ellipse6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62.8571,
    height: 62.8571,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.77637,
    y: 2.2251,
    width: 1.40452,
    height: 5.93178,
    fill: "#EEC143"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.66992,
    y: 4.44971,
    width: 5.61809,
    height: 1.48295,
    fill: "#EEC143"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4014,
    y: 14.8301,
    width: 1.40452,
    height: 5.93178,
    fill: "#EEC143"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45.2949,
    y: 17.0547,
    width: 5.61809,
    height: 1.48294,
    fill: "#EEC143"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.77637,
    y: 40.4121,
    width: 1.40452,
    height: 5.93178,
    fill: "#EEC143"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.66992,
    y: 42.6367,
    width: 5.61809,
    height: 1.48295,
    fill: "#EEC143"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.86565,
    height: 6.59639,
    transform: "matrix(0.979982 -0.00906755 0.0311888 1.01907 15.0908 31.7446)",
    fill: "#EEC143"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.94746,
    height: 6.45725,
    transform: "matrix(0.979982 -0.00906361 0.0312023 1.01907 50.0088 30.7944)",
    fill: "#EEC143"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8009,
    cy: 8.04982,
    rx: 19.8009,
    ry: 8.04982,
    transform: "matrix(0.979724 -0.0162787 0.0371393 1.01901 14.9512 29.3779)",
    fill: "#EEC143"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.802,
    cy: 7.33616,
    rx: 19.802,
    ry: 7.33616,
    transform: "matrix(0.979703 -0.0168245 0.0374893 1.019 14.8242 23.6616)",
    fill: "#FFE9AA"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7133,
    cy: 4.08843,
    rx: 15.7133,
    ry: 4.08843,
    transform: "matrix(0.979715 -0.0165193 0.0365982 1.01901 19.041 26.8838)",
    fill: "#F6D169"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0642 38.613L50.6235 38.5026L50.8348 41.2925L49.331 42.1336L49.0642 38.613Z",
    fill: "#D39900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1457 40.8272L44.7076 40.7342L44.9083 43.7642L43.3417 44.1669L43.1457 40.8272Z",
    fill: "#D39900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2143 41.9319L38.7785 41.8513L38.9619 44.9346L37.3528 45.0889L37.2143 41.9319Z",
    fill: "#D39900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9144 41.9033L32.4771 41.8501L32.628 45.2212L31.0115 45.1711L30.9144 41.9033Z",
    fill: "#D39900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9519 41.3736L26.5132 41.3815L26.5514 44.7101L24.9867 44.4084L24.9519 41.3736Z",
    fill: "#D39900"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0469 39.6445L20.6796 39.7346L20.5584 43.0939L18.9268 42.3573L19.0469 39.6445Z",
    fill: "#D39900"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 3.93056,
    height: 6.57381,
    transform: "matrix(0.829141 -0.56327 0.518273 0.852587 4.97949 29.4106)",
    fill: "#EEC143"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 4.01049,
    height: 6.43276,
    transform: "matrix(0.829139 -0.563273 0.51827 0.852588 34.2764 9.32666)",
    fill: "#EEC143"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8109,
    cy: 7.82337,
    rx: 19.8109,
    ry: 7.82337,
    transform: "matrix(0.825384 -0.568788 0.523912 0.84911 3.90723 27.8867)",
    fill: "#EEC143"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8019,
    cy: 7.10872,
    rx: 19.8019,
    ry: 7.10872,
    transform: "matrix(0.825124 -0.569168 0.524322 0.848856 0.967773 23.0781)",
    fill: "#FFE9AA"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.6873,
    cy: 3.90675,
    rx: 15.6873,
    ry: 3.90675,
    transform: "matrix(0.825446 -0.568698 0.524001 0.849055 6.10352 23.3877)",
    fill: "#F6D169"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3266 16.4795L38.6242 15.4845L40.1508 17.7443L39.253 19.3312L37.3266 16.4795Z",
    fill: "#D39900"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.378 21.6337L34.6851 20.6529L36.3169 23.1222L35.1548 24.3701L33.378 21.6337Z",
    fill: "#D39900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8698 25.85L30.1835 24.8794L31.825 27.4026L30.5079 28.4619L28.8698 25.85Z",
    fill: "#D39900"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4857 29.3047L24.8141 28.3564L26.5666 31.1441L25.1419 32.0354L23.4857 29.3047Z",
    fill: "#D39900"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1366 32.1372L19.4966 31.2399L21.1384 34.0686L19.6335 34.7163L18.1366 32.1372Z",
    fill: "#D39900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2693 33.8933L13.6693 33.0673L15.2041 36.032L13.4903 36.2997L12.2693 33.8933Z",
    fill: "#D39900"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3965 21.5037C14.5525 20.8364 15.3328 19.4573 17.2055 19.2793",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1748 15.2024C23.3309 14.5351 24.1112 13.156 25.9838 12.978",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2727 29.2396C38.7692 28.795 40.1664 28.159 41.7834 29.1721",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3186 20.6923C20.9671 20.7528 22.4557 20.4207 23.2224 18.6079",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8998 31.7662C31.3962 32.2108 32.7934 32.8469 34.4105 31.834",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.56177bfe597233cce3810f006b05c5c8.svg";
export { ForwardRef as ReactComponent };